import React from 'react'
import '../../../style/ksrtc/BrowseImage.scss'
import { Box } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete';

const BrowseImage = (props) => {
    const { handleImageModal, image = null, headerName = '', index, removeImage } = props
    return (
        <>
            {image == "" || image == null ?
                <Box className="imageBox">
                    <Box className="images" onClick={handleImageModal}>
                        <label for={`file-upload`} className="custom-file-upload">
                            <svg width="53" height="53" viewBox="0 0 53 53" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.83333 52.5C4.22917 52.5 2.8559 51.9288 1.71354 50.7865C0.571181 49.6441 0 48.2708 0 46.6667V5.83333C0 4.22917 0.571181 2.8559 1.71354 1.71354C2.8559 0.571181 4.22917 0 5.83333 0H32.0833V14.5833H37.9167V20.4167H52.5V46.6667C52.5 48.2708 51.9288 49.6441 50.7865 50.7865C49.6441 51.9288 48.2708 52.5 46.6667 52.5H5.83333ZM8.75 40.8333H43.75L32.8125 26.25L24.0625 37.9167L17.5 29.1667L8.75 40.8333ZM40.8333 17.5V11.6667H35V5.83333H40.8333V0H46.6667V5.83333H52.5V11.6667H46.6667V17.5H40.8333Z" fill="#CCE7FF" />
                            </svg>
                            Browse
                        </label>
                    </Box>

                    <Box sx={{ marginTop: '10px' }}>
                        <span style={{ fontSize: "14px" }}>{headerName}</span>
                    </Box>
                </Box>
                :
                <Box className="showImage" >
                    <Box className="image" onClick={handleImageModal}>
                        <img src={image} alt="" />
                    </Box>
                    <Box>
                        <span style={{ fontSize: "14px" }}>{headerName}</span>
                    </Box>
                    <Box className="icons">
                        <span className='deleteIcon' >
                            <label for={`file-uploads${index}`} className="custom-file-upload" onClick={handleImageModal} >
                                <EditIcon sx={{ fontSize: "12px", }} />
                            </label>
                        </span>
                        <span className='deleteIcon' onClick={removeImage}>
                            <DeleteIcon sx={{ fontSize: "12px", }} />
                        </span>
                    </Box>
                </Box>
            }
        </>
    )
}

export default BrowseImage